import { useSearchParams } from "react-router"

type QueryParam = { value: string | null; set(value: string | null): void }
export default function useQueryParam(key: string): QueryParam {
	const [searchParams, setSearchParams] = useSearchParams()
	return {
		value: searchParams.get(key),
		set(value: string | null) {
			const newParams = new URLSearchParams(searchParams)
			if (value !== null) {
				newParams.set(key, value)
			} else {
				newParams.delete(key)
			}
			setSearchParams(newParams)
		},
	}
}
